/**
 * Affichage des grades (Paladium) à partir du flag `PRIMARY_GROUP_ID` renvoyé
 * pour chaque joueur en ligne (voir PlayersMod : GetFlag("PRIMARY_GROUP_ID")).
 */

export interface RankDisplay {
  label: string;
  color: string;
  /** Poids hiérarchique (plus haut = grade plus élevé). Repris du RankUtility du PlayersMod. */
  weight: number;
}

const RANKS: Record<string, RankDisplay> = {
  admin: { label: 'Admin', color: '#E11D48', weight: 16 },
  dev: { label: 'Développeur', color: '#DB2777', weight: 15 },
  respstaff: { label: 'Resp. Staff', color: '#C026D3', weight: 14 },
  operator: { label: 'Opérateur', color: '#9333EA', weight: 13 },
  modo: { label: 'Modérateur', color: '#7C3AED', weight: 12 },
  helper: { label: 'Helper', color: '#2563EB', weight: 11 },
  affilate: { label: 'Affilié', color: '#0891B2', weight: 10 },
  divinite_gold: { label: 'Divinité Gold', color: '#D97706', weight: 8 },
  divinite: { label: 'Divinité', color: '#F59E0B', weight: 8 },
  legende: { label: 'Légende', color: '#CA8A04', weight: 6 },
  heros: { label: 'Héros', color: '#65A30D', weight: 4 },
  premium: { label: 'Premium', color: '#16A34A', weight: 3 },
  paladin: { label: 'Paladin', color: '#0D9488', weight: 2 },
  titan: { label: 'Titan', color: '#0EA5E9', weight: 1 },
  default: { label: 'Joueur', color: '#71717A', weight: 0 },
};

export function getRankDisplay(groupId?: string): RankDisplay {
  if (!groupId) return RANKS.default!;
  return RANKS[groupId.toLowerCase()] ?? { label: groupId, color: '#71717A', weight: 0 };
}

/**
 * Poids effectif d'un grade (comme RankUtility.GetRankWeight côté mod) :
 * +1 pour les grades donateurs premium (heros, legende, divinite, divinite_gold).
 */
export function getRankWeight(groupId?: string, isPremium?: boolean): number {
  const id = groupId?.toLowerCase();
  let weight = getRankDisplay(id).weight;
  if (isPremium && (id === 'heros' || id === 'legende' || id === 'divinite' || id === 'divinite_gold')) {
    weight += 1;
  }
  return weight;
}

/** Convertit un hex (#RRGGBB) en rgba avec l'alpha donné (pour les fonds de badge). */
export function hexToRgba(hex: string, alpha: number): string {
  const h = hex.replace('#', '');
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
